






































































































import { Vue, Component, Inject } from 'vue-property-decorator'
import { GetterCart, MutationCart } from '@/store/cart'
// import { GetterProduct, ProductItem } from '@/store/product'
import find from 'lodash/find'
import ProductModel from '@/api/model/product'

@Component
export default class ProductId extends Vue {
  // @GetterProduct
  // productAll: ProductItem[]

  @GetterCart
  selectedItems: ProductModel[]
  // selectedItems: { (selectedItems: ProductItem[]): void }

  @MutationCart
  setItemsArray: { (items: ProductModel[]): void }

  products: ProductModel[] = []

  get product (): ProductModel {
    // console.log('param:' + this.$route.params.name)
    this.products = JSON.parse(sessionStorage.getItem('productAll') || '{}')
    return find(this.products, (o) => o.name === this.$route.params.name)!
    // return find(this.productAll, (o) => o.name === this.$route.params.name)!
    // this.products = await this.productResource.productsTag(this.idList)
  }

  add (product: ProductModel) {
    let arrayData: ProductModel[] = []
    if (this.selectedItems && this.selectedItems.length > 0) {
      arrayData = this.selectedItems
    }
    if (product) {
      let itemExist = find(arrayData, (o) => o.name === product.name)
      console.log('Si existe')
      console.log(itemExist)
      if (itemExist) {
        itemExist.quantite = product.quantite
      } else {
        arrayData.push(product)
      }
      this.setItemsArray(arrayData)
      product.buy = false
    }
  }
}
